import React from 'react'
import { Breadcrumb, Button } from '../../../components/ui'
import { formatDepartmentMeta, getDepartmentsTotals } from './departmentListUtils'

function DepartmentsPageHeader({ departments, canCreate, onCreate }) {
  const meta = formatDepartmentMeta(getDepartmentsTotals(departments))

  return (
    <header className="departments-page-header">
      <Breadcrumb
        items={[
          { label: 'Главная', to: '/' },
          { label: 'Подразделения' },
        ]}
        className="departments-breadcrumb"
      />
      <div className="departments-titlebar">
        <div className="departments-titlebar-text">
          <h1 className="departments-page-title">Подразделения</h1>
          <p className="departments-page-subtitle">{meta}</p>
        </div>
        {canCreate && (
          <Button onClick={onCreate} variant="primary" className="departments-create-button">
            + Создать подразделение
          </Button>
        )}
      </div>
    </header>
  )
}

export default DepartmentsPageHeader
